import React from 'react'
import ReactMarkdown from 'react-markdown'

import styled from 'styled-components'
import { transparentize } from 'polished'
import { colors, fonts, padding } from '../styles'

import Button from './button'

const Block = (props) => {

    const {
        className,
        text_body,
        button_link,
        button_text,
        color
    } = props;

    return (
        <section className={className}>
            <div className="markdown">
                <ReactMarkdown source={text_body} />
            </div>
            <Button 
                link={button_link} 
                text={button_text}
                color={color}
            />
        </section>
    )
}

const bottomOffset = '6rem';

const StyledBlock = styled(Block)`
    padding: calc(1.5 * ${padding}) ${padding};
    background-color: ${props => transparentize(0.4, colors[props.color])};
    position: relative;
    padding-bottom: calc(2 * ${bottomOffset});
    display: flex;
    justify-content: center;
    align-items: center;

    &:after {
        content: '';
        display: block;
        background-color: ${props => transparentize(0.25, colors[props.color])};
        height: ${bottomOffset};
        width: 100%;
        position: absolute;
        right: 0;
        bottom: 0;
        left: 0;
    }

    @supports (mix-blend-mode: multiply) {
        background-color: ${props => transparentize(0.35, colors[props.color])};
        mix-blend-mode: multiply;
    }

    .markdown {
        ${fonts.lato()}
        color: ${colors.white};
        margin-bottom: 30px;
        text-align: center;
        max-width: 40rem;
        margin: 0 auto;
    }

    p {
        font-size: 1.25rem;
        line-height: 1.7;
    }

    .button {
        width: 20rem;
        margin: 0 auto;
        position: absolute;
        right: 0;
        left: 0;
        bottom: ${bottomOffset};
        z-index: 2;
        transform: translateY(50%);
    }
`

export default StyledBlock;